import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@utils/aggregation';

const { VOC } = PRODUCT_AREAS || {};
const { CAPTURE } = SUB_PRODUCT_AREAS || {};

export default {
    name: 'IdeaPollsCount',
    productArea: VOC,
    subProductArea: CAPTURE,
    responseFormat: 'row',
    build: () => {
        const pipeline = o.pipeline(
            o.sources.guides({
                appId: 'expandAppIds("*")',
            }),
            o.unwind('polls'),
            o.filter('polls.attributes.type == "Vote"'),
            o.group('id', o.groupField('ideasCount', o.count(null))),
            o.count(null),
        );

        return pipeline;
    },
};
